const Sessions = {

    // PAGE HEADER
    "sessions": "Sessions",

    // FIELDS
    "from_date": "From Date",
    "to_date": "To Date",

    // ERROR
    "error_from_date": "Select From Date",
    "error_to_date": "Select To Date",
    "error_date_range": "Start date should be less then End date.",

    // TABLE HEADER
    "table_session_id": "SESSION ID",
    "table_start_time": "SESSION START TIME",
    "table_end_time": "SESSION END TIME",
    "table_usage_volume": "USAGE-VOLUME",
    "table_usage_time": "USAGE-TIME",
    "table_ip_address": "IP ADDRESS",
    "table_mac_id": "MAC ID",
    "table_termination_cause": "TERMINATION CAUSE",

}

export default Sessions;
